
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiAssetEsperienzeGrid extends Serenity.EntityGrid<ProdottiAssetEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiAssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return ProdottiAssetEsperienzeDialog; }
        protected getIdProperty() { return ProdottiAssetEsperienzeRow.idProperty; }
        protected getInsertPermission() { return ProdottiAssetEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiAssetEsperienzeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}